import React, { useState } from "react";

const EditProfile = () => {
  const [profileImage, setProfileImage] = useState(null);

  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      setProfileImage(URL.createObjectURL(file));
    }
  };

  return (
    <>
      <style>{`
        .edit-profile-container {
          max-width: 800px;
          margin: 100px auto;
          padding: 30px;
          background: #fff;
          border-radius: 12px;
          box-shadow: 0 4px 12px rgba(0,0,0,0.1);
          font-family: Arial, sans-serif;
        }

        .profile-header {
          text-align: center;
          margin-bottom: 30px;
        }

        .profile-avatar {
          width: 120px;
          height: 120px;
          border-radius: 50%;
          object-fit: cover;
          border: 3px solid #28a745;
        }

        .upload-btn {
          margin-top: 10px;
        }

        .form-section {
          margin-bottom: 25px;
        }

        .form-section h5 {
          margin-bottom: 15px;
          font-weight: bold;
          color: #333;
        }

        .save-btn {
          background: #28a745;
          border: none;
          padding: 12px 30px;
          font-size: 16px;
          border-radius: 8px;
          color: #fff;
          font-weight: bold;
          transition: background 0.3s ease;
        }

        .save-btn:hover {
          background: #218838;
        }
      `}</style>

      <div className="edit-profile-container">
        {/* Header */}
        <div className="profile-header">
          <img
            src={
              profileImage ||
              "https://via.placeholder.com/120?text=Avatar"
            }
            alt="Profile"
            className="profile-avatar"
          />
          <div>
            <label className="btn btn-outline-success btn-sm upload-btn">
              Change Photo
              <input
                type="file"
                accept="image/*"
                hidden
                onChange={handleImageUpload}
              />
            </label>
          </div>
        </div>

        {/* Personal Info */}
        <div className="form-section">
          <h5>Personal Information</h5>
          <div className="row g-3">
            <div className="col-md-6">
              <label className="form-label">Full Name</label>
              <input type="text" className="form-control" placeholder="John Doe" />
            </div>
            <div className="col-md-6">
              <label className="form-label">Email</label>
              <input type="email" className="form-control" placeholder="johndoe@email.com" />
            </div>
            <div className="col-md-6">
              <label className="form-label">Phone</label>
              <input type="text" className="form-control" placeholder="+91 9876543210" />
            </div>
          </div>
        </div>

        {/* Address Info */}
        <div className="form-section">
          <h5>Address</h5>
          <div className="row g-3">
            <div className="col-12">
              <label className="form-label">Street</label>
              <input type="text" className="form-control" placeholder="123 Green Street" />
            </div>
            <div className="col-md-6">
              <label className="form-label">City</label>
              <input type="text" className="form-control" placeholder="New Delhi" />
            </div>
            <div className="col-md-4">
              <label className="form-label">State</label>
              <input type="text" className="form-control" placeholder="Delhi" />
            </div>
            <div className="col-md-2">
              <label className="form-label">Zip</label>
              <input type="text" className="form-control" placeholder="110001" />
            </div>
          </div>
        </div>

        {/* Security Info */}
        <div className="form-section">
          <h5>Change Password</h5>
          <div className="row g-3">
            <div className="col-md-6">
              <label className="form-label">New Password</label>
              <input type="password" className="form-control" />
            </div>
            <div className="col-md-6">
              <label className="form-label">Confirm Password</label>
              <input type="password" className="form-control" />
            </div>
          </div>
        </div>

        {/* Save Button */}
        <div className="text-center">
          <button className="save-btn">Save Changes</button>
        </div>
      </div>
    </>
  );
};

export default EditProfile;
